import React, { useEffect, useRef } from 'react';
import { Link } from 'react-scroll';
import { LinkedinIcon, GithubIcon, MailIcon, ArrowUpIcon } from 'lucide-react';
const Footer = ({
  language = 'en'
}) => {
  const footerRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const elements = entry.target.querySelectorAll('.fade-in');
          elements.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add('active');
            }, index * 100);
          });
        }
      });
    }, {
      threshold: 0.1
    });
    if (footerRef.current) {
      observer.observe(footerRef.current);
    }
    return () => {
      if (footerRef.current) {
        observer.unobserve(footerRef.current);
      }
    };
  }, []);
  const translations = {
    en: {
      home: 'Home',
      about: 'About',
      experience: 'Experience',
      contact: 'Contact',
      financeStudent: 'Finance Student & Entrepreneur',
      allRightsReserved: 'All rights reserved.'
    },
    vi: {
      home: 'Trang chủ',
      about: 'Giới thiệu',
      experience: 'Kinh nghiệm',
      contact: 'Liên hệ',
      financeStudent: 'Sinh viên Tài chính & Doanh nhân',
      allRightsReserved: 'Tất cả quyền được bảo lưu.'
    }
  };
  const t = translations[language];
  return <footer ref={footerRef} className="w-full py-12 bg-secondary relative" data-id="element-636">
      <div className="container mx-auto px-4" data-id="element-637">
        {/* Top gradient divider */}
        <div className="h-px w-full bg-gradient-to-r from-accent-cyan to-accent-violet mb-8" data-id="element-638"></div>
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-639">
          <div className="mb-6 md:mb-0 fade-in" data-id="element-640">
            <h2 className="text-2xl font-display font-bold gradient-text" data-id="element-641">
              Trung Nguyen
            </h2>
            <p className="text-muted mt-2" data-id="element-642">{t.financeStudent}</p>
          </div>
          <div className="flex space-x-8 mb-6 md:mb-0" data-id="element-643">
            {[{
            key: 'home',
            to: 'hero'
          }, {
            key: 'about',
            to: 'about'
          }, {
            key: 'experience',
            to: 'experience'
          }, {
            key: 'contact',
            to: 'contact'
          }].map((item, index) => <Link key={item.key} to={item.to} spy={true} smooth={true} offset={-70} duration={800} className="text-primary hover:text-accent-cyan animated-underline cursor-pointer transition-colors fade-in" style={{
            transitionDelay: `${index * 100}ms`
          }} data-id="element-644">
                {t[item.key]}
              </Link>)}
          </div>
          <div className="flex space-x-4 fade-in" data-id="element-645">
            <a href="https://www.linkedin.com/in/realtrungnguyen" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-background flex items-center justify-center hover:bg-accent-cyan/20 transition-all duration-300 hover:scale-110" data-id="element-646">
              <LinkedinIcon size={20} className="text-primary" data-id="element-647" />
            </a>
            <a href="#" className="w-10 h-10 rounded-full bg-background flex items-center justify-center hover:bg-accent-cyan/20 transition-all duration-300 hover:scale-110" data-id="element-648">
              <GithubIcon size={20} className="text-primary" data-id="element-649" />
            </a>
            <a href="mailto:officialtrungnguyen@gmail.com" className="w-10 h-10 rounded-full bg-background flex items-center justify-center hover:bg-accent-cyan/20 transition-all duration-300 hover:scale-110" data-id="element-650">
              <MailIcon size={20} className="text-primary" data-id="element-651" />
            </a>
          </div>
        </div>
        <div className="mt-8 text-center text-muted text-sm fade-in" data-id="element-652">
          <p data-id="element-653">
            &copy; {new Date().getFullYear()} Trung Nguyen.{' '}
            {t.allRightsReserved}
          </p>
        </div>
        {/* Back to top button */}
        <Link to="hero" spy={true} smooth={true} offset={-70} duration={800} className="absolute right-8 bottom-8 w-12 h-12 rounded-full bg-background flex items-center justify-center hover:bg-accent-cyan/20 transition-all duration-300 hover:scale-110 cursor-pointer" data-id="element-654">
          <ArrowUpIcon size={20} className="text-primary" data-id="element-655" />
        </Link>
      </div>
    </footer>;
};
export default Footer;